import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { Constants, Theme } from '@seedlang/constants';
import ArrowBox from 'components/arrow_box';
import FeedbackItem from 'components/feedback/feedback_item';
import Emoticon from 'components/feedback/emoticon';
import { isBlank } from '@seedlang/utils';
import { AppUI } from '@seedlang/state';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(9, 42px);
  grid-auto-rows: 42px;
  gap: 5px;
  padding: 4px 10px;
  background: white;
  box-sizing: border-box;
  width: 438px;
`;

const Background = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
`;

@observer
class FeedbackPicker extends React.Component {

  static defaultProps = {
    arrowBoxBottom: '35px',
    arrowBoxLeft: '-20px',
    arrowPosition: 'bottom',
    zIndex: Theme.z['dropdown-foreground'],
  };

  render() {
    return (
      <div>
        <Background
          onClick={this.props.onClose}
        />
        <ArrowBox
          show
          boxShadow={this.props.boxShadow}
          arrowPosition={this.props.arrowPosition}
          arrowPositionLeft={this.props.arrowPositionLeft}
          arrowPositionRight={this.props.arrowPositionRight}
          width='440px'
          height='150px'
          zIndex={this.props.zIndex}
          top={this.props.arrowBoxTop}
          bottom={this.props.arrowBoxBottom}
          left={this.props.arrowBoxLeft}
          right={this.props.arrowBoxRight}
        >
          <Wrapper>
            {
              Constants.FEEDBACK_OPTIONS.map(item => {
                if (isBlank(item.site) || item.site.includes(AppUI.site.id)) {
                  return (
                    <FeedbackItem
                      key={item.feedbackType}
                      margin='0'
                      onClick={() => this.props.onClick(item.feedbackType)}
                    >
                      <Emoticon
                        image={item.image}
                      />
                    </FeedbackItem>
                  );
                }
                return null;
              })
            }
          </Wrapper>
        </ArrowBox>
      </div>
    );
  }
}

export default ErrorBoundary(FeedbackPicker);
